import { PolicyConfigDecisionComponentResultTypes } from "@enums/policy-config-decision-component-result-type";
import { SelectOption } from "@idw-types/common";

export const POLICY_CONFIG_DECISION_COMPONENT_RESULT_OPTIONS: Array<SelectOption> = [
    { label: "Pass", value: PolicyConfigDecisionComponentResultTypes.PASS },
    { label: "Fail", value: PolicyConfigDecisionComponentResultTypes.FAIL }
];